import React from 'react';

export function Clock(props) {
    return (
        <svg viewBox="0 0 22 22" {...props}>
            <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round" transform="translate(1 1)">
                <circle cx={10} cy={10} r={10} />
                <path d="M10 4v6l4 2" />
            </g>
        </svg>
    );
}
